import React, { Component } from "react";
import { Link } from "react-router-dom";

class bookRank extends Component {
	constructor(props) {
		super(props);

		this.state = { totalcount: 0, curpageidx: 0, booklist: [], loading: true };
		this.dofetchdata();
	}

	componentWillMount() {
		var self = this;
		window.addEventListener('scroll', function () {
			if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
				console.log("you're at the bottom of the page");
				if (self.state.loading === false) {
					//self.dofetchdata();
				}
			}
		});
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll, true);
	}

	dofetchdata() {

		this.state.loading = true;
		//alert(JSON.stringify(this.state));
		fetch(`/api/AB/BookRankList?pgidx=${this.state.curpageidx}&pgsize=50&&orderby=1&orderway=1`)
			.then(response => response.json())
			.then(data => {
				
				this.state.curpageidx++;
				this.state.loading = false;

				this.state.booklist.push(...data.lstresult);

				this.setState({ totalcount: data.totalcount, curpageidx: this.state.curpageidx, booklist: this.state.booklist, loading: false });
				this.dorender();
			});

	}

	dorender() {
		//alert(JSON.stringify(this.state));
		let bookDummy = this.state.booklist;
		//alert(JSON.stringify(bookDummy));

		return (
			bookDummy.map((book, index) => {
				//alert(JSON.stringify(book));
				return (
					<React.Fragment>
						<li className="bookRank-item">
							<Link to={`/book/${book.refbookid}`}>
								<div className="bookRank-num-container">
									<div className="bookRank-num">{index + 1}</div>
								</div>
								<div className="bookList-thumbnail">
									<div className="thumbnail">
										<img
											className="thumbnail-image"
											src={`/api/AB/GetCoverImage?thumb=2&imgid=${book.refbookid}`}
											alt={book.subject}
										/>
									</div>
								</div>
								<div className="bookList-info">
									<h3 className="bookList-title">{book.subject}</h3>
									<h4 className="bookList-author">{book.authorName}</h4>
									<h4 className="bookList-publisher">{book.publisherName}</h4>
								</div>
							</Link>
						</li>
					</React.Fragment>
				);
			})

		);
	}

	render() {
		let contents = this.state.loading === true ? "loading..." : this.dorender();

		return (
			<ul className="bookRank">
				{contents}
			</ul>
		);
	}
}

export default bookRank;
